import React from 'react'

class TierSelect extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			selectedTier: ''
		}
	}

	handleChange(e){
		this.setState({ selectedTier: e.target.value })
	}

	render() {
		return (
			<select className="tier" value={this.props.selectedTier} onChange={this.handleChange.bind(this)}>
				<option value="-1">Select Tier...</option>
				{this.props.tiers.map( tier => <option key={tier} value={tier}>{decodeURIComponent(tier)}</option> )}
			</select>
		)
	}
}

export default TierSelect



// WEBPACK FOOTER //
// ./src/components/tier_select.js